<script>
    import { page } from "$app/stores";
    import Bundle from "./Bundle.svelte";

    export let course_slug = null;
    export let worksheet_slug = null;

    let bundles = $page.data.bundles;

    let className = '';
    export {className as class};
    export let feature = 'bundle-list';

    let course;
    let worksheet;

    if (course_slug) {
        bundles = bundles.filter(bundle => bundle.items.some(item => item.type === 'course' && item.slug === course_slug));
        course = bundles?.[0]?.items?.find(item => item.type === 'course' && item.slug === course_slug) || undefined;
    }

    if (worksheet_slug) {
        bundles = bundles.filter(bundle => bundle.items.some(item => item.type === 'worksheet' && item.slug === worksheet_slug));
        worksheet = bundles?.[0]?.items?.find(item => item.type === 'worksheet' && item.slug === worksheet_slug) || undefined;
    }


</script>

{#each bundles as bundle}
    <Bundle {bundle} {course} {worksheet} class="{className}" {feature} />
{/each}